<template>
    <PageCard title="Attendance Records">
        <TabContainer
            :tabs="Object.values(ATTENDANCE_RECORD_TABS)"
            :selectedTab="attendanceRecordTab"
            @change="attendanceRecordTab = $event"
        />
        <div v-if="attendanceRecordTab.name == ATTENDANCE_RECORD_TABS.ATTENDANCE.name">
            <AttendanceDateController />
            <div class="att-search-bar">
                <i class="fas fa-search att-search-icon"></i>
                <input v-model="searchText" type="text" class="att-search-input" placeholder="Search employee by name..." />
                <span v-if="searchText" class="att-search-clear" @click="searchText = ''">
                    <i class="fas fa-times"></i>
                </span>
            </div>
            <div class="att-section-label">
                <span>Employees</span>
                <span class="att-record-count" v-if="filteredAttendanceRecordsForDate.length">
                    {{ filteredAttendanceRecordsForDate.length }} record{{ filteredAttendanceRecordsForDate.length !== 1 ? 's' : '' }}
                </span>
            </div>
            <div v-if="initLoading || loadingAttendanceData" class="att-loading">
                <Spinner />
            </div>

            <div v-if="!initLoading && !loadingAttendanceData && !filteredAttendanceRecordsForDate.length" class="att-empty">
                <i class="fas fa-calendar-xmark"></i>
                <p>No attendance records found</p>
            </div>
            <div v-else class="att-list">
                <AttendanceRecordListItem
                    :attendanceRecord="attendanceRecord"
                    :key="attendanceRecord.id"
                    v-for="attendanceRecord of filteredAttendanceRecordsForDate"
                />
            </div>
        </div>
        <div v-if="attendanceRecordTab.name == ATTENDANCE_RECORD_TABS.MAPS.name">
            <AttendanceMap />
        </div>
    </PageCard>
</template>

<script>
import AttendanceDateController from "./attendance-date-controller.vue"
import AttendanceRecordListItem from "./attendance-record-list-item.vue"
import { mapActions, mapState } from "vuex"
import TabContainer from "../../../components/layout/TabContainer.vue"
import AttendanceMap from "./attendance-map.vue"
import PageCard from "../../../components/layout/PageCard.vue"
import Spinner from "../../../components/UI/Spinner.vue"
import { convertAmPmToTimestamp } from "../../../utils/common"

const ATTENDANCE_RECORD_TABS = {
    ATTENDANCE: { name: "ATTENDANCE", value: "Attendance Stats" },
    MAPS: { name: "MAPS", value: "Map View" },
}

export default {
    components: {
        AttendanceDateController,
        TabContainer,
        AttendanceRecordListItem,
        AttendanceMap,
        PageCard,
        Spinner,
    },
    data() {
        return {
            initLoading: true,
            searchText: "",
            ATTENDANCE_RECORD_TABS,
            attendanceRecordTab: ATTENDANCE_RECORD_TABS.ATTENDANCE,
        }
    },
    async mounted() {
        await this.fetchRecordsByDate()
        // await this.fetchAttendanceInfo()
        this.initLoading = false
    },
    computed: {
        ...mapState("misc", ["loadingAttendanceData", "attendanceRecordsForDate"]),
        filteredAttendanceRecordsForDate() {
            const filtered = this.attendanceRecordsForDate.filter(
                (item) => item.user && item.user.fullName && item.user.fullName.toLowerCase().includes(this.searchText.toLowerCase())
            )

            // sort the resutls based on ascending order of timein
            const sortedRecords = filtered.sort((a, b) => {
                if (a.timeIn && b.timeIn) {
                    return convertAmPmToTimestamp(a.timeIn) < convertAmPmToTimestamp(b.timeIn) ? -1 : 1
                } else {
                    return 0
                }
            })

            return sortedRecords
        },
    },
    methods: {
        ...mapActions("misc", ["fetchRecordsByDate", "fetchAttendanceInfo"]),
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.att-search-bar {
    position: relative;
    display: flex;
    align-items: center;
    margin: 16px 0;
}
.att-search-icon {
    position: absolute;
    left: 14px;
    color: $gray400;
    font-size: 14px;
    pointer-events: none;
}
.att-search-input {
    width: 100%;
    padding: 11px 40px 11px 40px;
    border: 1px solid $gray200;
    border-radius: $radiusSm;
    font-size: 14px;
    color: $gray700;
    background: $gray50;
    transition: all $transitionFast;
    outline: none;
    font-family: inherit;

    &::placeholder {
        color: $gray400;
    }
    &:focus {
        border-color: $primaryColor;
        box-shadow: 0 0 0 3px rgba(0, 94, 137, 0.1);
        background: white;
    }
}
.att-search-clear {
    position: absolute;
    right: 14px;
    color: $gray400;
    cursor: pointer;
    font-size: 13px;
    transition: color $transitionFast;

    &:hover {
        color: $gray600;
    }
}
.att-section-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    span:first-child {
        font-size: 14px;
        font-weight: 600;
        color: $gray800;
    }
}
.att-record-count {
    font-size: 12px;
    color: $gray400;
    font-weight: 500;
}
.att-loading {
    display: flex;
    justify-content: center;
    padding: 40px 0;
}
.att-empty {
    text-align: center;
    padding: 48px 20px;
    color: $gray400;

    i {
        font-size: 36px;
        margin-bottom: 10px;
        display: block;
    }
    p {
        font-size: 14px;
        margin: 0;
        color: $gray500;
    }
}
.att-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

@media (max-width: 480px) {
    .att-search-input {
        font-size: 16px;
    }
}
</style>
